import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export class Responses extends AbstractChart {
    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                width: 70,
                marginLeft: -15,
                spacingTop: 10,
                marginBottom: 36,
                plotBorderWidth: 0,
                type: 'columnrange',
                inverted: true,
            },
            yAxis: [{
                min: -1,
                max: 100,
                title: {
                    text: null
                },
                labels: {
                    enabled: false
                },
                gridLineWidth: 0,
            }],
            xAxis: {
                labels: {
                    enabled: false
                },
                gridLineWidth: 0,
                lineWidth: 0
            },
            plotOptions: {
                columnrange: {
                    grouping: false
                },
            },
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

export default function () {registerPlugin(Responses)}